import { useState, useEffect } from 'react';
import './App.css';
import Home from './Home';
import Manifesto from './Manifesto';
import { LANG_CODES, DEFAULT_LANG, findLang } from './languages';

const LANG_KEY = 'allin.lang';

function getRoute() {
  if (typeof window === 'undefined') return 'home';
  return window.location.hash.startsWith('#/manifesto') ? 'manifesto' : 'home';
}

function App() {
  const [route, setRoute] = useState(getRoute);
  const [lang, setLang] = useState(() => {
    if (typeof window === 'undefined') return DEFAULT_LANG;
    const saved = window.localStorage?.getItem(LANG_KEY);
    return LANG_CODES.includes(saved) ? saved : DEFAULT_LANG;
  });

  // route sync
  useEffect(() => {
    const onHashChange = () => {
      const next = getRoute();
      setRoute((prev) => {
        if (prev !== next) window.scrollTo({ top: 0, behavior: 'auto' });
        return next;
      });
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  // lang sync
  useEffect(() => {
    try {
      window.localStorage?.setItem(LANG_KEY, lang);
      const meta = findLang(lang);
      document.documentElement.setAttribute('lang', meta.htmlLang);
      document.title = meta.title;
    } catch (e) {}
  }, [lang]);

  if (route === 'manifesto') {
    return <Manifesto lang={lang} setLang={setLang} />;
  }
  return <Home lang={lang} setLang={setLang} />;
}

export default App;
